module.exports = __webpack_public_path__ + "img/server_down.d0ffe1e3.svg";